import {
    Box,
    Card,
    Step,
    StepLabel,
    Stepper,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import "styles/loader.css";
import * as Styles from "pages/requests/stepsIndividual/submitted/submitted.styes";
import { useTenantContext } from "contexts/tenantContext";

interface IProps { 
    //? PROPS //
    showStepper?: boolean;
}

const Submitted = ({showStepper}: IProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.between("xs", "md"));
    const { currentTenant } = useTenantContext();

    const steps = [
        t("steps.step1"),
        t("steps.step2"),
        t("steps.step3"),
        t("steps.step4"),
        t("steps.step5"),
    ];

    useEffect(() => {
    });

    return (
        <Box maxWidth="lg" sx={Styles.wrapper(theme)}>
            {!showStepper && 
                <Stepper activeStep={5} sx={Styles.stepper(theme)}>
                    {steps.map((label, index) => {
                        if (label !== "") {
                            return (
                                <Step key={label}>
                                    <StepLabel>{isMobile ? "" : label}</StepLabel>
                                </Step>
                            );
                        }
                        return "";
                    })}
                </Stepper>
            }

            {isMobile ? (
                <Box sx={Styles.containerCSS(theme)}>
                    <h1>{t("requestIndividual.step5.messages.documentSubmitted.title")}</h1>
                    <Box sx={Styles.infotext(theme)}>
                        <Trans 
                            i18nKey={'requestIndividual.step5.messages.documentSubmitted.text'} 
                            values={{
                                email: currentTenant ? currentTenant.email : 'pz.antwerpen.screening@police.belgium.eu',
                                tel: currentTenant ? currentTenant.tel : '03 338 55 55'
                            }}
                        />
                    </Box>
                </Box>
            ) : (
                <Card sx={Styles.cardCSS(theme)}>
                    <Box sx={Styles.containerCSS(theme)}>
                        <h1>{t("requestIndividual.step5.messages.documentSubmitted.title")}</h1>
                        <Box sx={Styles.infotext(theme)}>
                            <Trans 
                                i18nKey={'requestIndividual.step5.messages.documentSubmitted.text'} 
                                values={{
                                    email: currentTenant ? currentTenant.email : 'pz.antwerpen.screening@police.belgium.eu',
                                    tel: currentTenant ? currentTenant.tel : '03 338 55 55'
                                }}
                            />
                        </Box>
                    </Box>
                </Card>
            )}
        </Box>
    );
};

export default Submitted;
